import cache from './cache.module';

export default cache;
